<agpr-panel
    header="AMT.newswire"
    [marginTop]="20"
>
    <div class="agpr-wire-prefs-header">
        <agpr-button
            label="AMT.newswire.addQuota"
            [style]="buttonTypes.tertiary"
            (click)="showRegionDropdown = !showRegionDropdown"
            [disabled]="isReadOnly || regionDropdownOptions?.length === 0"
        >
        </agpr-button>
        <agpr-dropdown
            *ngIf="showRegionDropdown"
            id="newswirePreferences-region-dropdown"
            class="agpr-regionDropdown"
            [options]="optionsToDisplay"
            placeholder="AMT.newswire.addRegionPlaceholder"
            [(ngModel)]="selectedRegion"
            (ngModelChange)="addQuota($event.value)"
            ariaLabel="AMT.newswire.addRegionPlaceholder"
        >
        </agpr-dropdown>
    </div>
    <div *ngFor="let quota of wireQuotas; let i = index" class="agpr-contextMenu-parent">
        <div #quotaCard
            class="agpr-quotaCard"
            id="{{i}}"
        >
            <h5 class="agpr-headerH3-dark">{{'WireRegion.' + quota.region | localize}}</h5>
            <div class="agpr-quotaCard-content">
                <div class="agpr-column">
                    <agpr-number-input
                        id="wireQuota.baselineWiress"
                        [(ngModel)]="quota.baselineWires"
                        [disabled]="isReadOnly"
                        label="AMT.newswire.releaseQuota"
                        [integerOnly]="true"
                        [min]="0"
                        [max]="2000000000"
                    ></agpr-number-input>
                    <agpr-number-input
                        id="wireQuota.additionalWires"
                        [(ngModel)]="quota.additionalWires"
                        [disabled]="isReadOnly"
                        label="AMT.newswire.additionalReleases"
                        [integerOnly]="true"
                        [min]="0"
                        [max]="2000000000"
                    ></agpr-number-input>
                </div>
                <div class="agpr-column">
                    <agpr-text-input
                        id="wireQuota.usedWires"
                        [(ngModel)]="quota.usedWires"
                        label="AMT.newswire.usedReleases"
                        [disabled]="true"
                    ></agpr-text-input>
                    <agpr-text-input
                        id="wireQuota.remainingWires"
                        [ngModel]="+quota.baselineWires + +quota.additionalWires - +quota.usedWires"
                        label="AMT.newswire.remainingReleases"
                        [disabled]="true"
                    ></agpr-text-input>
                </div>
            </div>
            <div class="agpr-contextMenu top right">
                <agpr-button
                    [icon]="'fa-regular fa-duotone fa-trash-can'"
                    (click)="removeQuota(i)"
                    *ngIf="!isReadOnly"
                    tooltip="AMT.newswire.deleteRegionQuota"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </div>
        </div>
    </div>
</agpr-panel>
